export const visit = (vm, at) => {
at({ "de": { "pricing-page-components": { "phone-support": { "seePhoneNumber": "Telefonnummer anzeigen" } } } });
};